import { TL } from "./turbolinks";
import { initMenu } from "./menu";
import { Player } from "./player";
import { resizeImages } from "./creations";
import { initAlbums } from "./albums";

// Init Turbolinks et compatibilité avec les plugins jQuery utilisés.
TL.start();

// Menu
TL.bind("load", initMenu);

// Player audio
Player.register();

// taille des images des pages de rubriques projets
TL.bind("load", resizeImages);
window.addEventListener("resize", resizeImages);

// Arranger les albums photos
TL.bind("load", initAlbums);
